import { Component, HostListener, inject, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { PrimeNGConfig } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { environment } from 'src/environments/environment';
import { AppResource } from './app.resource';
import { Resource } from './resources/resource';
import { VyvToastComponent } from './shared/components/vyv-toast/vyv-toast.component';
import { AppInsightsService } from './shared/services/app-insight.service';
import { GtmService } from './shared/services/google-tag-manager.service';
import { WINDOW, WindowRef } from './shared/services/window.service';
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ToastModule, VyvToastComponent],
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  title = 'template-parcours';
  resource: Resource;
  private windowRef = inject<WindowRef>(WINDOW);

  constructor(
    private config: PrimeNGConfig,
    private appInsightService: AppInsightsService,
    private router: Router,
    private gtmService: GtmService,
    protected resources: AppResource,
  ) {
    this.resource = resources['resource'];
    this.preloadSVG();
  }

  ngOnInit(): void {
    this.config.setTranslation(this.resource.primeng);

    document.dispatchEvent(new Event('tarteaucitron_config'));

    this.gtmService.init(environment.googleTagManagerId);
    this.trackPageViews();
  }

  private trackPageViews(): void {
    this.gtmService.pushEvent('page_view', {
      page_path: this.router.url,
      page_title: document.title,
    });
  }

  loadScript(_url: string) {
    let node = document.createElement('script');
    node.src = _url;
    node.type = 'text/javascript';
    document.getElementsByTagName('head')[0].appendChild(node);
  }

  @HostListener('document:appInsights_allowed', ['$event'])
  onAppInsightsAllowed(ev: any) {
    this.appInsightService.initAppInsights();
  }

  @HostListener('document:appInsights_disallowed', ['$event'])
  onAppInsightsDisallowed(ev: any) {
    this.appInsightService.disableAppInsights();
  }

  preloadSVG() {
    var svgs = [this.resource.header.logo];
    var frag = new Array<Node>();

    svgs.forEach(item => {
      var res = document.createElement('link');
      res.rel = 'preload';
      res.type = 'image/svg+xml';
      res.as = 'image';
      res.href = item;
      frag.push(res);
    });

    document.getElementsByTagName('head')[0].append(...frag);
  }
}
